var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 128,
    viewBox: "0 0 112 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5897_10610)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 48.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 56.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 64.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 72.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 80.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 88.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 96.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 104.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 112.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 120.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 40.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 32.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 24.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 16.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 8.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 7.8,
    height: 7.8,
    stroke: "#F4B346",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 101.5L0 121.5V128H112V45L87.5 87.5L65.5 83.5L46.5 105.5L21 101.5Z",
    fill: "url(#paint0_linear_5897_10610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5059 99.385L21.5058 99.385C21.2124 99.3368 20.9123 99.3581 20.628 99.4471C20.3438 99.5361 20.0831 99.6904 19.865 99.8979L19.8648 99.8981L0.466507 118.419L0.465115 118.42C0.0578845 118.817 -0.180006 119.364 -0.198796 119.941C-0.217585 120.517 -0.0158618 121.08 0.364296 121.504C0.744707 121.928 1.27308 122.179 1.83387 122.199C2.39471 122.219 2.93856 122.005 3.34607 121.609L3.34613 121.609L21.5484 103.873C21.7287 103.697 21.9811 103.617 22.2297 103.655L46.6485 107.456C46.6489 107.456 46.6493 107.456 46.6496 107.457C46.9657 107.509 47.2892 107.475 47.589 107.36C47.889 107.244 48.1544 107.05 48.3601 106.798L48.3602 106.798L65.7266 85.4464C65.9098 85.2211 66.2006 85.1128 66.4865 85.1634L87.584 88.8954L87.6188 88.6984L87.584 88.8954C87.9135 88.9536 88.2521 88.906 88.5543 88.7595C88.8565 88.613 89.1074 88.375 89.2749 88.0783L103.791 62.4398C104.08 61.9285 104.804 61.8933 105.142 62.3742L107.336 65.4991C107.964 66.3926 109.361 66.052 109.507 64.9699L111.874 47.4309C112.017 46.3694 110.803 45.6663 109.954 46.3185L96.2424 56.844C95.399 57.4915 95.752 58.8349 96.8048 58.984L100.659 59.5302C101.22 59.6096 101.523 60.2308 101.24 60.7217L87.3526 84.8228C87.1834 85.1164 86.8477 85.2715 86.5145 85.2101L65.6668 81.3689C65.6666 81.3689 65.6664 81.3689 65.6663 81.3688C65.3697 81.3135 65.0644 81.3397 64.7809 81.4448C64.4972 81.5499 64.2458 81.7299 64.051 81.9662L46.5126 103.102C46.3312 103.32 46.0473 103.426 45.767 103.38L21.5059 99.385Z",
    fill: "#FF882F",
    stroke: "#FF882F",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5897_10610",
    x1: 58.5,
    y1: 57,
    x2: 56,
    y2: 138.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF882F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF882F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5897_10610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticOrange);
export default __webpack_public_path__ + "static/media/statisticOrange.eb7ed58ba2fe4de031b7ca7b86412455.svg";
export { ForwardRef as ReactComponent };